import { Icon, tokens } from '@consumer/ui'

// Positioning wrapper around the shared icon (CBP-3939);
// the SVG geometry now lives in @consumer/ui.
const InfoCircleSVG = () => (
  <span style={{ position: 'absolute', left: 0, display: 'inline-flex' }}>
    <Icon name="infoCircle" color={tokens.colors.brand.secondaryGrey} />
  </span>
)
export default InfoCircleSVG
